import type { MetadataState } from '../../ParseCSVModal.js'
import { SamplingEndConfig, SamplingStartConfig } from '../ForDateTime/DateTimeConfig.js'
import type { CSVMappingResult } from '../../CSVModalTypes.js'
import { DateTime } from 'luxon'

/**
 * Validate that sampling start and end times are in order
 * @param state
 * @param csvResult
 * @constructor
 */
export function ValidateStartAndEndSamplingDate(
  state: MetadataState,
  csvResult: CSVMappingResult[],
): string[] {
  if (!state[SamplingStartConfig.label] || !state[SamplingEndConfig.label]) return []

  const errorCount = csvResult.filter(x =>
    (x.metadata.samplingStart
    && x.metadata.samplingEnd
    && DateTime.fromISO(x.metadata.samplingStart) > DateTime.fromISO(x.metadata.samplingEnd)) ||
    (!!x.metadata.samplingStart != !!x.metadata.samplingEnd)
  ).length

  if (errorCount > 0) {
    return [
      `${errorCount} rows contain an invalid start-end sampling date combination`
    ]
  }
  return []
}